// extracted by mini-css-extract-plugin
export default {"user-avatar":"_3VqQ_","userAvatar":"_3VqQ_","pixelated":"nrRJ7"};